// [AR-10101] NVP subnav based on MLPNav
var NVPNav = (function ($el) {
  Utility.log('NVPNav.js loaded');

  var nvpNav = {};

  var $window = $(window);

  var swipeStartY;

  var swipeEndY;

  var translate = 0;

  var maxTranslate = 0;

  var debounce;

  var navSwitchWidth = null;

  var navLargePadding = 70; // 35px on each side @ large BP

  // NVP Nav Basic Constructor
  function NVPNav($el) {
    this.$el = $el;

    this.$section = this.$el.children('section');

    this.$button = this.$section.children('button');

    this.$buttonSVG = this.$button.children('svg');

    this.$hamburger = this.$el.children('aside[role=menu]');

    this.$navContainer = this.$el.children('section');

    this.$desktopNav = this.$navContainer.children('ul');

    return this;
  }

  function _toggleHamburger() {
    nvpNav.$hamburger.slideToggle({
      start: function () {
        $(this).css('display', 'flex');
      },
      complete: function () {
        _setMaxTranslate();

        if ($(this).is(':visible')) {
          $(this).css('display', 'flex');
        }
      },
    });

    // Flip flop the arrow icon
    nvpNav.$buttonSVG.each(function () {
      if ($(this).attr('class').indexOf('hidden') !== -1) {
        $(this).attr('class', 'acr-icon');
      } else {
        $(this).attr('class', 'acr-icon hidden');
      }
    });
  }

  function init() {
    // Bail if this element DNE
    if ($el.length === 0) {
      return null;
    }

    // Otherwise initialize the constructor
    nvpNav = new NVPNav($el);

    // Set Overview button up arrow to hidden on mobile
    $('.nvp-nav > section > button > svg:nth-child(2)')
      .attr('class', 'acr-icon hidden');

    $('.acr-header > div').css('position', 'relative');

    nvpNav.$button.on('click.nvpNav', _toggleHamburger);

    $window.on('resize', _attachResize);

    _attachTouch();

    // throwing this inside a timeOut to prevent incorrect
    // element widths being returned
    // causing navStyle to change at the wrong times
    setTimeout(function () {
      // set navSwitchWidth
      navSwitchWidth = nvpNav.$desktopNav.width();

      // kick off the first resize event
      _onResize();
    }, 50);

    return this;
  }

  function _attachTouch() {
    nvpNav.$hamburger.off('touchstart', _touchStartHandler)
      .on('touchstart', _touchStartHandler);

    nvpNav.$hamburger.off('touchmove', _touchMoveHandler)
      .on('touchmove', _touchMoveHandler);

    nvpNav.$hamburger.off('touchend', _touchEndHandler)
      .on('touchend', _touchEndHandler);
  }

  function _touchStartHandler(e) {
    swipeStartY = e.originalEvent.touches[0].clientY;

    translate = parseInt(mlpNav.$hamburger.css('top'), 10);

    nvpNav.$hamburger.removeClass('acr-animation');
  }

  function _touchMoveHandler(e) {
    var dY;

    var top;

    swipeEndY = e.originalEvent.touches[0].clientY;

    dY = swipeStartY - swipeEndY;

    dY *= -1;

    top = translate + dY;

    if (top > 0) {
      top = 0;
    } else if (top * -1 > maxTranslate) {
      top = maxTranslate * -1;
    }

    nvpNav.$hamburger.css('top', top.toString() + 'px');

    nvpNav.$hamburger.addClass('acr-animation');
  }

  function _touchEndHandler() {
    swipeStartY = null;

    swipeEndY = null;
  }

  function _setMaxTranslate() {
    var menuBarHeight = nvpNav.$section.height();

    var viewPortHeight = window.innerHeight;

    var hamburgerViewPortH = viewPortHeight - menuBarHeight;

    maxTranslate = Math.abs(nvpNav.$hamburger.height() - hamburgerViewPortH);
  }

  function _attachResize() {
    clearTimeout(debounce);

    debounce = setTimeout(_onResize, 250);
  }

  function _onResize() {
    setNavStyle();
  }


  function setNavStyle() {
    var hamburgerView = (nvpNav.$navContainer.innerWidth() < navSwitchWidth + navLargePadding);

    if (window.innerWidth > Constants.breakpoints.lg - 1
      && hamburgerView === false) {

      activateDesktopNav();
    } else {
      activateHamburgerNav();
    }
  }

  function activateHamburgerNav() {
    nvpNav.$el.removeClass('desktop-nav').addClass('hamburger-nav');
  }

  function activateDesktopNav() {
    nvpNav.$el.removeClass('hamburger-nav').addClass('desktop-nav');
  }

  return {
    init: init,
  };
}($('.nvp-nav')));
